module.exports = __webpack_public_path__ + "media/images/newsletter/setouchi/btn-action-445c3bdfa7463b2ca41deb3eb8f3b491.svg";